import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('LegalEntityGroupList', LegalEntityGroupListData);

    function LegalEntityGroupListData() {
        LegalEntityGroupList.prototype = {
            build: build,
            isDefaultGroup: isDefaultGroup,
        };

        function LegalEntityGroupList(legalEntityGroupListData) {
            if (legalEntityGroupListData) {
                this.build(legalEntityGroupListData);
            }
        }

        return LegalEntityGroupList;

        /////////////////////

        function build(legalEntityGroupListData) {
            this.id = legalEntityGroupListData.id;
            this.name = legalEntityGroupListData.name;
            this.type = legalEntityGroupListData.type;
            this.description = legalEntityGroupListData.description
                ? legalEntityGroupListData.description +
                  (this.isDefaultGroup() ? ' ' + legalEntityGroupListData.legalEntityName : '')
                : '';
            this.nbLegalEntities = legalEntityGroupListData.nbLegalEntities || null;
            this.nbSubEntities = legalEntityGroupListData.nbSubEntities || null;
            this.nbDivisions = legalEntityGroupListData.nbDivisions || null;
            this.principalName = legalEntityGroupListData.principalName;
        }

        function isDefaultGroup() {
            return this.type === 'ALL' || this.type === 'INVITED_SELLER';
        }
    }
})();
